import React, { useEffect, useState } from 'react';
import EventEmitter from 'UTILS/emitter';

export const StpContext = React.createContext({});
StpContext.name = 'StpContext';

export const StpProvider = ({ children, parameters }) => {
  const getStyles = (params) => {
    return '';
  }

  const hasDecimalPlaces = () => {
    if (!showDecimalPlaces) return 0;
    if (showDecimalPlaces && numDecimalPlaces) return Number(numDecimalPlaces);
    return 2;
  };

  const context = {
    ...parameters,
    getStyles,
    hasDecimalPlaces,
  };

  return <StpContext.Provider value={ context }>{children}</StpContext.Provider>;
};